export default __webpack_public_path__ + "images/24d3aa1e5d32a512bda3a6900c25da1c-orchestra.jpg";